module.exports = __webpack_public_path__ + "img/transfer-flying-icon.14b6f599.svg";